
import styles from '../ProductInfo.module.css';

interface Color {
    name: string;
    hex: string;
}

interface Font {
    name: string;
    file: string;
    family: string;
}

interface DesignSelectorsProps {
    selectedColor: Color;
    setSelectedColor: (color: Color) => void;
    selectedFont: Font;
    setSelectedFont: (font: Font) => void;
    colors: Color[];
    fonts: Font[];
    locations: string[];
    selectedLocation: string;
    setSelectedLocation: (location: string) => void;
    isColorDropdownOpen: boolean;
    setIsColorDropdownOpen: (isOpen: boolean) => void;
    isFontDropdownOpen: boolean;
    setIsFontDropdownOpen: (isOpen: boolean) => void;
    onOpenGuide: () => void;
}

export const DesignSelectors = ({
    selectedColor,
    setSelectedColor,
    selectedFont,
    setSelectedFont,
    colors,
    fonts,
    locations,
    selectedLocation,
    setSelectedLocation,
    isColorDropdownOpen,
    setIsColorDropdownOpen,
    isFontDropdownOpen,
    setIsFontDropdownOpen,
    onOpenGuide
}: DesignSelectorsProps) => {
    return (
        <div className={styles.typoSection}>
            <div className={styles.typoHeader}>
                <h4 className={styles.customizationTitle} style={{ marginBottom: 0 }}>Élements typographiques</h4>
                <a href="#" className={styles.guideLink} onClick={(e) => { e.preventDefault(); onOpenGuide(); }}>Guide Emplacement broderie</a>
            </div>

            <div className={styles.selectorsGrid}>
                {/* Custom Color Selector */}
                <div className={styles.selectGroup}>
                    <div className={styles.customDropdownWrapper}>
                        <div
                            className={styles.customDropdownButton}
                            onClick={() => setIsColorDropdownOpen(!isColorDropdownOpen)}
                        >
                            <span className={styles.colorCircle} style={{ backgroundColor: selectedColor.hex }}></span>
                            <span className={styles.selectedColorName}>{selectedColor.name}</span>
                        </div>
                        {isColorDropdownOpen && (
                            <div className={styles.customDropdownMenu}>
                                {colors.map((color, idx) => (
                                    <div
                                        key={idx}
                                        className={styles.dropdownItem}
                                        onClick={() => {
                                            setSelectedColor(color);
                                            setIsColorDropdownOpen(false);
                                        }}
                                    >
                                        <span className={styles.colorCircle} style={{ backgroundColor: color.hex }}></span>
                                        {color.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Typo Selector */}
                <div className={styles.selectGroup}>
                    <div className={styles.customDropdownWrapper}>
                        <div
                            className={styles.customDropdownButton}
                            onClick={() => setIsFontDropdownOpen(!isFontDropdownOpen)}
                        >
                            <span className={styles.selectedFontName} style={{ fontFamily: selectedFont.family }}>
                                {selectedFont.name}
                            </span>
                        </div>
                        {isFontDropdownOpen && (
                            <div className={styles.customDropdownMenu}>
                                {fonts.map((font, idx) => (
                                    <div
                                        key={idx}
                                        className={styles.dropdownItem}
                                        onClick={() => {
                                            setSelectedFont(font);
                                            setIsFontDropdownOpen(false);
                                        }}
                                        style={{ fontFamily: font.family, fontSize: '1.2rem' }}
                                    >
                                        {font.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Placement Selector */}
                <div className={styles.selectGroup}>
                    <div className={styles.customDropdownWrapper}>
                        <select
                            className={styles.customSelect}
                            value={selectedLocation}
                            onChange={(e) => setSelectedLocation(e.target.value)}
                        >
                            {locations.map((loc, idx) => (
                                <option key={idx} value={loc}>{loc}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
};
